import React from "react";

import styles from "./InputWrapper.module.scss";

type InputWrapperType = {
  children: React.ReactNode;
  label: string | React.ReactNode;
  errorMsg?: string;
  hasError?: boolean;
  optional?: boolean;
};

const InputWrapper: React.FC<InputWrapperType> = ({
  children,
  errorMsg,
  hasError,
  label,
  optional,
}) => {
  const showErrorMsg = errorMsg && hasError;

  return (
    <fieldset className={styles.fieldWrapper}>
      <div className={styles.fieldLabelContainer}>
        {optional ? (
          <>
            <label className={styles.fieldLabelWithSpanAndOptional}>
              {label}
            </label>
            <span className={styles.optionalTag}>Optional</span>
          </>
        ) : (
          <label className={styles.fieldLabel}>{label}</label>
        )}
      </div>

      {children}

      {showErrorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
    </fieldset>
  );
};

export default InputWrapper;
